import { IUser } from 'src/utils/interfaces/user';
import React from 'react';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getBrandByDealerNumber, getFooterLink } from 'src/utils/helpers';
import './header.scss';

const Header: React.FC = () => {
    const { contactInfo } = useLocalization();
    const { i18n } = useTranslation();
    let brand = 'vw';
    const currentDealers = useSelector((state: IUser) => {
        return state.currentDealers;
    });
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    if (currentDealers && dealerDataInfo) {
        const { dealer } = dealerDataInfo;
        brand = getBrandByDealerNumber(dealer.brand, dealer.dealerNumber);
    }
    const lang = i18n?.language?.includes('fr') ? 'fr' : 'en';
    const contactUrl = getFooterLink('contact', lang, true, brand);
    return (
        <div className='contact-info-header'>
            <div className='contact-info-header_label'>
                {contactInfo.HEADER_LABEL}
            </div>
            <div className='contact-info-header_link'>
                <a href={contactUrl} target='_blank' rel='noreferrer'>
                    {contactInfo.HEADER_LINK_LABEL}
                </a>
            </div>
        </div>
    );
};

export default Header;
